import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './SelectStatus.module.scss';
import classNames from 'classnames/bind';
import BaseSelect from '~/components/common/base-select/BaseSelect';
import { SelectOptions } from '~/utils/types/common';
import { useEffect, useState } from 'react';
import { useAppSelector } from '~/redux/hooks';
import { IJobStatus } from '~/utils/interface/master';
import { cast } from '~/utils/helper';

export type SelectStatusProps = {
  name?: string;
  label?: string;
  options?: SelectOptions;
  value?: string;
  info?: boolean;
  onChange?: (value: string) => void;
  disabled?: boolean;
};

const cx = classNames.bind(styles);

const SelectStatus = (props: SelectStatusProps) => {
  //#region Destructuring Props
  const { info, onChange, disabled, ...restProps } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation('admin/component');
  const { jobStatuses } = useAppSelector((state) => state.master);

  //#endregion Declare Hook

  //#region Declare State
  const label = props.label || t('selectStatus.label');
  const [value, setValue] = useState<string>();

  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    if (props.value) setValue(String(props.value));
  }, [props.value]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleSelectChange = (newValue: string) => {
    if (!disabled) {
      setValue(newValue);
      if (onChange) {
        onChange(newValue);
      }
    }
  };

  const renderStatusComponent = (item: IJobStatus) => {
    return (
      <Box
        className={cx('status')}
        style={{
          color: item.color,
          backgroundColor: item.backgroundColor,
          opacity: disabled ? 0.5 : 1,
        }}
      >
        <Box>{item.name}</Box>
      </Box>
    );
  };

  const renderSelectedStatusComponent = (item: IJobStatus) => {
    return (
      <Box
        className={cx('status')}
        style={{
          color: item.color,
          backgroundColor: item.backgroundColor,
          opacity: disabled ? 0.5 : 1,
        }}
      >
        <Box className='ml-[8px]'>{item.name}</Box>
      </Box>
    );
  };
  //#endregion Handle Function

  return (
    <>
      <BaseSelect
        {...restProps}
        onChange={(e) => handleSelectChange(e.target.value)}
        value={cast(value)}
        menuClassName={cx('select-status-menu')}
        label={label}
        options={jobStatuses}
        renderSelected={(item: IJobStatus) => renderSelectedStatusComponent(item)}
        renderOptionItem={(item: IJobStatus) => renderStatusComponent(item)}
        disabled={disabled}
      />
    </>
  );
};

export default SelectStatus;
